module.exports = __webpack_public_path__ + "img/booth-list.66ddc1df.svg";